export default "__VITE_ASSET__DvVxadHt__"